import {
    Chart as ChartJS,
    LinearScale,
    CategoryScale,
    BarElement,
    PointElement,
    LineElement,
    Legend,
    Tooltip,
    LineController,
    BarController,
    Title
  } from 'chart.js';
  
  import { Chart } from 'react-chartjs-2';
  
  ChartJS.register(
    LinearScale,
    CategoryScale,
    BarElement,
    PointElement,
    LineElement,
    Legend,
    Tooltip,
    LineController,
    BarController,
    Title
  );
  
  const StackGenericBarchart = ({title, bardata_desmotado, bardata_no_desmotado, labels, 
    dataset_desmotado_label, dataset_no_desmotado_label}: any) => {
    
    const type = "bar"

    const options = {
    responsive: true,
    scales: {
        x: {
          stacked: true,
        },
        y: {
          stacked: true,
        },
      },
    maintainAspectRatio: false,
    plugins: {
        legend: {
          position: 'bottom' as const,
        },
        title: {
          display: true,
          text: title,
        },
      }
    }  
  
    // Para las barras  
    const data = {
      labels,
      datasets: [
        {
          label: dataset_desmotado_label,
          data: bardata_desmotado,
          backgroundColor: '#98BF06',
        },
        {
          label: dataset_no_desmotado_label,
          data: bardata_no_desmotado,
          backgroundColor: 'rgb(0, 125, 173)',
        }
      ],
  };
  
    return (<Chart type={type} data={data} options={options}/>)
  
  }
  
  export default StackGenericBarchart;